<template>
  <b-card no-body class="all-images h-100 bg-dark-navy custom border-0">
    <template v-slot:header>
      <b-row class=" mb-0" >
        <b-col cols="8" >
          <font-awesome-icon :icon="getIcon()" size="lg" class="mr-1"></font-awesome-icon> {{ getPhase() }}
        </b-col>
        <b-col  cols="4" align-self="center" class="text-right">
          <h6 class="color-white pt-0 mb-0">{{ projects.find((project) => project._id === projectId).name }}</h6>
        </b-col>
      </b-row>
    </template>
    <b-card-body class="h-100 p-0">
      <b-tabs card pills nav-wrapper-class="nav-wrapper rounded-0 border-0 pt-0" content-class="overflow-y scroll-overflow h-100 dashboards" fill v-model="tabIndex">
        <b-tab title="Comparative AI" active>
          <div class="px-3 py-2 h-100" v-if="tabIndex === 0">
            <b-row align-h="between" class="pb-0 mb-0">
              <b-col align-self="end" cols="9">
                <h6 class="text-white ml-2 mt-2">Comparative AI Evaluation Selector</h6>
              </b-col>
            </b-row>
            <hr class="mt-0 border-info" />
            <b-row>
              <b-col cols="3">
                <b-dropdown class="btn px-3 btn-sm btn-yellow rounded-pill ml-3" :text="comparativeAi ? comparativeAi.name : 'Not selected ...'" variant="warn" :disabled="compStatus === 'Loading'">
                  <b-dropdown-item v-for="value in availableProjects" :key="'project_' + value._id" @click="comparativeAi = value">{{ value.name }}</b-dropdown-item>
                </b-dropdown>
              </b-col>
              <b-col cols="9">
                <div v-if="comparativeAi && compStatus === 'Loaded'">
                  <h6 class="text-white font-weight-400"><b>{{ comparativeAi.name }}</b> Details</h6>
                  <b-row>
                    <b-col cols="2">AI Evaluation Set-up</b-col>
                    <b-col cols="10">
                      Tags: <b>{{ this.comparativeAi.tags.length }}</b><br />
                      Primary pathologies: <b>{{ this.comparativeAi.pathologies.filter(p => p.primary).length }}</b><br />
                      Secondary pathologies: <b>{{ this.comparativeAi.pathologies.filter(p => !p.primary).length }}</b><br />
                      Primary diagnoses: <b>{{ this.comparativeAi.diagnosis.filter(p => p.primary).length }}</b><br />
                      Secondary diagnoses: <b>{{ this.comparativeAi.diagnosis.filter(p => !p.primary).length }}</b><br />
                      Subgroups: <b>{{ this.comparativeAi.subgroups.length }}</b>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="2">Images</b-col>
                    <b-col cols="10">
                      Labelled: <b>{{ this.compImages.labelledImages.length }}</b><br />
                      Processed: <b>{{ this.compImages.aiImages.length }}</b>
                    </b-col>
                  </b-row>
                </div>
                <div v-else-if="compStatus === 'Loading'">
                  <h6 class="text-white ml-2 mt-2">Loading Comparative AI Evaluation Data.<br /><small>Please, be patient - it may take a little time.</small></h6>
                </div>
                <div v-else>
                  <h6 class="text-white ml-2 mt-2">Please, select AI Evaluation to compare.<br /><small>RATify will load AI Evaluation data and provide comparative analysis.</small></h6>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-tab>
        <b-tab title="AI Performance Summary" :disabled="compStatus !== 'Loaded'">
          <div class="px-3 py-2" v-if="tabIndex === 1">
            <b-row align-h="between" class="pb-0 mb-0">
              <b-col align-self="end" cols="9">
                <h6 class="text-white ml-2 mt-2">AI Performance Summary Comparison</h6>
              </b-col>
              <b-row cols="3" class="py-1 mb-0 mx-1 px-2">
                <b-col cols="6" class="py-0 mx-0 px-1 d-flex">
                  <b-dropdown class="btn px-3 btn-sm btn-yellow rounded-pill mr-2" :text="threshold.toFixed(2)" variant="warn">
                    <b-dropdown-item v-for="value in Array.from({ length: 19 }, (_, i) => (i + 1) * 0.05)" :key="'threshold_' + value" @click="threshold = value">{{ value.toFixed(2) }}</b-dropdown-item>
                  </b-dropdown>
                  <b-dropdown class="btn px-3 btn-sm btn-yellow rounded-pill" :text="filterChoice === '' ? 'All' : filterChoice" variant="warn">
                    <b-dropdown-item @click="filterChoice = 'All'">All</b-dropdown-item>
                    <b-dropdown-item v-for="sg in project.subgroups" :key="sg.name" @click="filterChoice = sg.name">{{ sg.name }}</b-dropdown-item>
                  </b-dropdown>
                </b-col>
              </b-row>
            </b-row>
            <hr class="mt-0 border-info" />
            <b-row>
              <b-col cols="3" class="mt-2">
                <b class="ml-2">{{ this.list[0].name }}</b>
                <apexchart height="320" :options="cmOptions" :series="cmSeries"></apexchart>
              </b-col>
              <b-col cols="3" class="mt-2">
                <b class="ml-2">{{ this.comparativeAi.name }}</b>
                <apexchart height="320" :options="compCmOptions" :series="compCmSeries"></apexchart>
              </b-col>
              <b-col cols="6" class="mt-2">
                <b-row>
                  <b-col cols="3"><b>Metric</b></b-col>
                  <b-col cols="3" class="text-right"><b>{{ list[0].name }}</b></b-col>
                  <b-col cols="3" class="text-right"><b>{{ comparativeAi.name }}</b></b-col>
                  <b-col cols="3" class="text-right"><b>Difference</b></b-col>
                </b-row>
                <b-row class="mb-1">
                  <b-col cols="3">Sensitivity</b-col>
                  <b-col cols="3" class="text-right"><b>{{ (confusionMatrix.sensitivity * 100).toFixed(2) }}%</b></b-col>
                  <b-col cols="3" class="text-right"><b>{{ (compConfusionMatrix.sensitivity * 100).toFixed(2) }}%</b></b-col>
                  <b-col cols="3" class="text-right"><b>{{ ((confusionMatrix.sensitivity - compConfusionMatrix.sensitivity) * 100).toFixed(2) }}%</b></b-col>
                </b-row>
                <b-row class="mb-1">
                  <b-col cols="3">Specificity</b-col>
                  <b-col cols="3" class="text-right"><b>{{ (confusionMatrix.specificity * 100).toFixed(2) }}%</b></b-col>
                  <b-col cols="3" class="text-right"><b>{{ (compConfusionMatrix.specificity * 100).toFixed(2) }}%</b></b-col>
                  <b-col cols="3" class="text-right"><b>{{ ((confusionMatrix.specificity - compConfusionMatrix.specificity) * 100).toFixed(2) }}%</b></b-col>
                </b-row>
                <b-row class="mb-1">
                  <b-col cols="3">Precision</b-col>
                  <b-col cols="3" class="text-right"><b>{{ (confusionMatrix.precision * 100).toFixed(2) }}%</b></b-col>
                  <b-col cols="3" class="text-right"><b>{{ (compConfusionMatrix.precision * 100).toFixed(2) }}%</b></b-col>
                  <b-col cols="3" class="text-right"><b>{{ ((confusionMatrix.precision - compConfusionMatrix.precision) * 100).toFixed(2) }}%</b></b-col>
                </b-row>
                <b-row class="mb-1">
                  <b-col cols="3">NPV</b-col>
                  <b-col cols="3" class="text-right"><b>{{ (confusionMatrix.npv * 100).toFixed(2) }}%</b></b-col>
                  <b-col cols="3" class="text-right"><b>{{ (compConfusionMatrix.npv * 100).toFixed(2) }}%</b></b-col>
                  <b-col cols="3" class="text-right"><b>{{ ((confusionMatrix.npv - compConfusionMatrix.npv) * 100).toFixed(2) }}%</b></b-col>
                </b-row>
                <b-row class="mb-1">
                  <b-col cols="3">Accuracy</b-col>
                  <b-col cols="3" class="text-right"><b>{{ (confusionMatrix.accuracy * 100).toFixed(2) }}%</b></b-col>
                  <b-col cols="3" class="text-right"><b>{{ (compConfusionMatrix.accuracy * 100).toFixed(2) }}%</b></b-col>
                  <b-col cols="3" class="text-right"><b>{{ ((confusionMatrix.accuracy - compConfusionMatrix.accuracy) * 100).toFixed(2) }}%</b></b-col>
                </b-row>
                <b-row class="mb-1">
                  <b-col cols="3">F1 Score</b-col>
                  <b-col cols="3" class="text-right"><b>{{ (confusionMatrix.f1 * 100).toFixed(2) }}%</b></b-col>
                  <b-col cols="3" class="text-right"><b>{{ (compConfusionMatrix.f1 * 100).toFixed(2) }}%</b></b-col>
                  <b-col cols="3" class="text-right"><b>{{ ((confusionMatrix.f1 - compConfusionMatrix.f1) * 100).toFixed(2) }}%</b></b-col>
                </b-row>
                <b-row class="mb-1">
                  <b-col cols="3">AUC</b-col>
                  <b-col cols="3" class="text-right"><b>{{ (combinedAuc.selected.auc * 100).toFixed(2) }}%</b></b-col>
                  <b-col cols="3" class="text-right"><b>{{ (combinedAuc.comparative.auc * 100).toFixed(2) }}%</b></b-col>
                  <b-col cols="3" class="text-right"><b>{{ ((combinedAuc.selected.auc - combinedAuc.comparative.auc) * 100).toFixed(2) }}%</b></b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6" class="mt-2">
                <apexchart :options="aucOptions" :series="aucSeries"></apexchart>
              </b-col>
              <b-col cols="6" class="mt-2">
                <apexchart :options="prOptions.options" :series="prOptions.series"></apexchart>
              </b-col>
            </b-row>
          </div>
        </b-tab>
        <b-tab title="AI Threshold Analysis" :disabled="compStatus !== 'Loaded'">
          <div class="px-3 py-2" v-if="tabIndex === 2">
            <b-row align-h="between" class="pb-0 mb-0">
              <b-col align-self="end" cols="8">
                <h6 class="text-white ml-2 mt-2">AI Threshold Analysis</h6>
              </b-col>
              <b-col cols="4" class="py-0 mx-0 px-1 d-flex">
                <b-button pill variant="yellow" class="px-4 mr-2 mb-1 mx-auto" size="sm" @click.prevent="exportToCSV">Export to CSV</b-button>
                <b-dropdown class="btn px-3 btn-sm btn-yellow rounded-pill mr-2 mb-1" :text="threshold.toFixed(2)" variant="warn">
                  <b-dropdown-item v-for="value in Array.from({ length: 19 }, (_, i) => (i + 1) * 0.05)" :key="'threshold_' + value" @click="threshold = value">{{ value.toFixed(2) }}</b-dropdown-item>
                </b-dropdown>
                <b-dropdown class="btn px-3 btn-sm btn-yellow rounded-pill mb-1 mr-3" :text="filterChoice === '' ? 'All' : filterChoice" variant="warn">
                  <b-dropdown-item @click="filterChoice = 'All'">All</b-dropdown-item>
                  <b-dropdown-item v-for="sg in project.subgroups" :key="sg.name" @click="filterChoice = sg.name">{{ sg.name }}</b-dropdown-item>
                </b-dropdown>
              </b-col>
            </b-row>
            <hr class="mt-0 border-info" />
            <div class="my-3">
              <div class="float-right">
                <small class="ml-2 mr-1 d-inline-block">
                  <b-badge pill class="bg-green color-black py-1 px-2 font-weight-400">0.95</b-badge>
                </small>
                <small>= Better value</small>
              </div>
              <h6 class="mr-3 color-white"><span class="font-weight-400">Left: </span>{{ list[0].name }} - <span class="font-weight-400">Right: </span>{{ comparativeAi.name }}</h6>
            </div>
            <div class="table-container">
              <!-- Frozen threshold column -->
              <div class="frozen-column bg-navy">
                <table class="table table-sm bg-navy">
                  <thead class="bg-navy">
                    <tr>
                      <th class="threshold-header text-center bg-navy">Threshold</th>
                    </tr>
                  </thead>
                  <tbody class="bg-navy">
                    <tr v-for="(item, index) in comparisonData" :key="'frozen-' + index" :class="index % 2 === 0 ? '' : 'table-striped-row'">
                      <td class="threshold-cell text-center">
                        <small>{{ item.threshold.toFixed(2) }}</small>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Scrollable table -->
              <div class="scrollable-table">
                <b-table striped :items="comparisonData" :fields="fields" small responsive="false" class="comparison-table">
                  <!-- Custom styling for alternating column backgrounds -->
                  <template #thead-top>
                    <tr>
                      <th v-for="(field, index) in fields" :key="'header-' + index" :class="{'bg-navy': index % 2 === 1, 'border-bottom-0': true}">
                        <div class="text-center"><small><small>Left - Right</small></small></div>
                      </th>
                    </tr>
                  </template>
                  <!-- Sensitivity Columns -->
                  <template #cell(sensitivity)="data">
                    <b-row class="m-0 p-0">
                      <b-col cols="5" class="text-right p-0">
                        <small v-if="isBetter(data.item.sensitivity1, data.item.sensitivity2)">
                          <b-badge pill class="bg-green color-black py-1 px-2 font-weight-400">
                            {{ !Number.isNaN(data.item.sensitivity1) ? data.item.sensitivity1.toFixed(2) : '-' }}
                          </b-badge>
                        </small>
                        <small v-else>
                          {{ !Number.isNaN(data.item.sensitivity1) ? data.item.sensitivity1.toFixed(2) : '-' }}
                        </small>
                      </b-col>
                      <b-col cols="2" class="text-center p-0">
                        <small class="text-muted">-</small>
                      </b-col>
                      <b-col cols="5" class="text-left p-0">
                        <small v-if="isBetter(data.item.sensitivity2, data.item.sensitivity1)">
                          <b-badge pill class="bg-green color-black py-1 px-2 font-weight-400">
                            {{ !Number.isNaN(data.item.sensitivity2) ? data.item.sensitivity2.toFixed(2) : '-' }}
                          </b-badge>
                        </small>
                        <small v-else>
                          {{ !Number.isNaN(data.item.sensitivity2) ? data.item.sensitivity2.toFixed(2) : '-' }}
                        </small>
                      </b-col>
                    </b-row>
                  </template>
                  <!-- Specificity Columns -->
                  <template #cell(specificity)="data">
                    <b-row class="m-0 p-0">
                      <b-col cols="5" class="text-right p-0">
                        <small v-if="isBetter(data.item.specificity1, data.item.specificity2)">
                          <b-badge pill class="bg-green color-black py-1 px-2 font-weight-400">
                            {{ !Number.isNaN(data.item.specificity1) ? data.item.specificity1.toFixed(2) : '-' }}
                          </b-badge>
                        </small>
                        <small v-else>
                          {{ !Number.isNaN(data.item.specificity1) ? data.item.specificity1.toFixed(2) : '-' }}
                        </small>
                      </b-col>
                      <b-col cols="2" class="text-center p-0">
                        <small class="text-muted">-</small>
                      </b-col>
                      <b-col cols="5" class="text-left p-0">
                        <small v-if="isBetter(data.item.specificity2, data.item.specificity1)">
                          <b-badge pill class="bg-green color-black py-1 px-2 font-weight-400">
                            {{ !Number.isNaN(data.item.specificity2) ? data.item.specificity2.toFixed(2) : '-' }}
                          </b-badge>
                        </small>
                        <small v-else>
                          {{ !Number.isNaN(data.item.specificity2) ? data.item.specificity2.toFixed(2) : '-' }}
                        </small>
                      </b-col>
                    </b-row>
                  </template>
                  <!-- Accuracy Columns -->
                  <template #cell(accuracy)="data">
                    <b-row class="m-0 p-0">
                      <b-col cols="5" class="text-right p-0">
                        <small v-if="isBetter(data.item.accuracy1, data.item.accuracy2)">
                          <b-badge pill class="bg-green color-black py-1 px-2 font-weight-400">
                            {{ data.item.accuracy1.toFixed(2) }}
                          </b-badge>
                        </small>
                        <small v-else>
                          {{ data.item.accuracy1.toFixed(2) }}
                        </small>
                      </b-col>
                      <b-col cols="2" class="text-center p-0">
                        <small class="text-muted">-</small>
                      </b-col>
                      <b-col cols="5" class="text-left p-0">
                        <small v-if="isBetter(data.item.accuracy2, data.item.accuracy1)">
                          <b-badge pill class="bg-green color-black py-1 px-2 font-weight-400">
                            {{ data.item.accuracy2.toFixed(2) }}
                          </b-badge>
                        </small>
                        <small v-else>
                          {{ data.item.accuracy2.toFixed(2) }}
                        </small>
                      </b-col>
                    </b-row>
                  </template>
                  <!-- NPV Columns -->
                  <template #cell(NPV)="data">
                    <b-row class="m-0 p-0">
                      <b-col cols="5" class="text-right p-0">
                        <small v-if="isBetter(data.item.NPV1, data.item.NPV2)">
                          <b-badge pill class="bg-green color-black py-1 px-2 font-weight-400">
                            {{ data.item.NPV1 >= 0 ? data.item.NPV1.toFixed(2) : '-' }}
                          </b-badge>
                        </small>
                        <small v-else>
                          {{ data.item.NPV1 >= 0 ? data.item.NPV1.toFixed(2) : '-' }}
                        </small>
                      </b-col>
                      <b-col cols="2" class="text-center p-0">
                        <small class="text-muted">-</small>
                      </b-col>
                      <b-col cols="5" class="text-left p-0">
                        <small v-if="isBetter(data.item.NPV2, data.item.NPV1)">
                          <b-badge pill class="bg-green color-black py-1 px-2 font-weight-400">
                            {{ data.item.NPV2 >= 0 ? data.item.NPV2.toFixed(2) : '-' }}
                          </b-badge>
                        </small>
                        <small v-else>
                          {{ data.item.NPV2 >= 0 ? data.item.NPV2.toFixed(2) : '-' }}
                        </small>
                      </b-col>
                    </b-row>
                  </template>
                  <!-- PPV (Precision) Columns -->
                  <template #cell(PPV)="data">
                    <b-row class="m-0 p-0">
                      <b-col cols="5" class="text-right p-0">
                        <small v-if="isBetter(data.item.precision1, data.item.precision2)">
                          <b-badge pill class="bg-green color-black py-1 px-2 font-weight-400">
                            {{ data.item.precision1 >= 0 ? data.item.precision1.toFixed(2) : '-' }}
                          </b-badge>
                        </small>
                        <small v-else>
                          {{ data.item.precision1 >= 0 ? data.item.precision1.toFixed(2) : '-' }}
                        </small>
                      </b-col>
                      <b-col cols="2" class="text-center p-0">
                        <small class="text-muted">-</small>
                      </b-col>
                      <b-col cols="5" class="text-left p-0">
                        <small v-if="isBetter(data.item.precision2, data.item.precision1)">
                          <b-badge pill class="bg-green color-black py-1 px-2 font-weight-400">
                            {{ data.item.precision2 >= 0 ? data.item.precision2.toFixed(2) : '-' }}
                          </b-badge>
                        </small>
                        <small v-else>
                          {{ data.item.precision2 >= 0 ? data.item.precision2.toFixed(2) : '-' }}
                        </small>
                      </b-col>
                    </b-row>
                  </template>
                  <!-- FPR Columns -->
                  <template #cell(FPR)="data">
                    <b-row class="m-0 p-0">
                      <b-col cols="5" class="text-right p-0">
                        <small v-if="isBetter(data.item.FPR2, data.item.FPR1)"> <!-- Note: For FPR, lower is better -->
                          <b-badge pill class="bg-green color-black py-1 px-2 font-weight-400">
                            {{ data.item.FPR1 >= 0 ? data.item.FPR1.toFixed(2) : '-' }}
                          </b-badge>
                        </small>
                        <small v-else>
                          {{ data.item.FPR1 >= 0 ? data.item.FPR1.toFixed(2) : '-' }}
                        </small>
                      </b-col>
                      <b-col cols="2" class="text-center p-0">
                        <small class="text-muted">-</small>
                      </b-col>
                      <b-col cols="5" class="text-left p-0">
                        <small v-if="isBetter(data.item.FPR1, data.item.FPR2)"> <!-- Note: For FPR, lower is better -->
                          <b-badge pill class="bg-green color-black py-1 px-2 font-weight-400">
                            {{ data.item.FPR2 >= 0 ? data.item.FPR2.toFixed(2) : '-' }}
                          </b-badge>
                        </small>
                        <small v-else>
                          {{ data.item.FPR2 >= 0 ? data.item.FPR2.toFixed(2) : '-' }}
                        </small>
                      </b-col>
                    </b-row>
                  </template>
                  <!-- TPR Columns -->
                  <template #cell(TPR)="data">
                    <b-row class="m-0 p-0">
                      <b-col cols="5" class="text-right p-0">
                        <small v-if="isBetter(data.item.TPR1, data.item.TPR2)">
                          <b-badge pill class="bg-green color-black py-1 px-2 font-weight-400">
                            {{ data.item.TPR1 >= 0 ? data.item.TPR1.toFixed(2) : '-' }}
                          </b-badge>
                        </small>
                        <small v-else>
                          {{ data.item.TPR1 >= 0 ? data.item.TPR1.toFixed(2) : '-' }}
                        </small>
                      </b-col>
                      <b-col cols="2" class="text-center p-0">
                        <small class="text-muted">-</small>
                      </b-col>
                      <b-col cols="5" class="text-left p-0">
                        <small v-if="isBetter(data.item.TPR2, data.item.TPR1)">
                          <b-badge pill class="bg-green color-black py-1 px-2 font-weight-400">
                            {{ data.item.TPR2 >= 0 ? data.item.TPR2.toFixed(2) : '-' }}
                          </b-badge>
                        </small>
                        <small v-else>
                          {{ data.item.TPR2 >= 0 ? data.item.TPR2.toFixed(2) : '-' }}
                        </small>
                      </b-col>
                    </b-row>
                  </template>
                  <!-- F1 Columns -->
                  <template #cell(F1)="data">
                    <b-row class="m-0 p-0">
                      <b-col cols="5" class="text-right p-0">
                        <small v-if="isBetter(data.item.F1_1, data.item.F1_2)">
                          <b-badge pill class="bg-green color-black py-1 px-2 font-weight-400">
                            {{ data.item.F1_1 >= 0 ? data.item.F1_1.toFixed(2) : '-' }}
                          </b-badge>
                        </small>
                        <small v-else>
                          {{ data.item.F1_1 >= 0 ? data.item.F1_1.toFixed(2) : '-' }}
                        </small>
                      </b-col>
                      <b-col cols="2" class="text-center p-0">
                        <small class="text-muted">-</small>
                      </b-col>
                      <b-col cols="5" class="text-left p-0">
                        <small v-if="isBetter(data.item.F1_2, data.item.F1_1)">
                          <b-badge pill class="bg-green color-black py-1 px-2 font-weight-400">
                            {{ data.item.F1_2 >= 0 ? data.item.F1_2.toFixed(2) : '-' }}
                          </b-badge>
                        </small>
                        <small v-else>
                          {{ data.item.F1_2 >= 0 ? data.item.F1_2.toFixed(2) : '-' }}
                        </small>
                      </b-col>
                    </b-row>
                  </template>
                  <!-- Recall Columns -->
                  <template #cell(recall)="data">
                    <b-row class="m-0 p-0">
                      <b-col cols="5" class="text-right p-0">
                        <small v-if="isBetter(data.item.recall1, data.item.recall2)">
                          <b-badge pill class="bg-green color-black py-1 px-2 font-weight-400">
                            {{ data.item.recall1 >= 0 ? data.item.recall1.toFixed(2) : '-' }}
                          </b-badge>
                        </small>
                        <small v-else>
                          {{ data.item.recall1 >= 0 ? data.item.recall1.toFixed(2) : '-' }}
                        </small>
                      </b-col>
                      <b-col cols="2" class="text-center p-0">
                        <small class="text-muted">-</small>
                      </b-col>
                      <b-col cols="5" class="text-left p-0">
                        <small v-if="isBetter(data.item.recall2, data.item.recall1)">
                          <b-badge pill class="bg-green color-black py-1 px-2 font-weight-400">
                            {{ data.item.recall2 >= 0 ? data.item.recall2.toFixed(2) : '-' }}
                          </b-badge>
                        </small>
                        <small v-else>
                          {{ data.item.recall2 >= 0 ? data.item.recall2.toFixed(2) : '-' }}
                        </small>
                      </b-col>
                    </b-row>
                  </template>
                  <!-- Error Columns -->
                  <template #cell(error)="data">
                    <b-row class="m-0 p-0">
                      <b-col cols="5" class="text-right p-0">
                        <small v-if="isBetter(data.item.error2, data.item.error1)"> <!-- For error, lower is better -->
                          <b-badge pill class="bg-green color-black py-1 px-2 font-weight-400">
                            {{ data.item.error1 >= 0 ? data.item.error1.toFixed(2) : '-' }}
                          </b-badge>
                        </small>
                        <small v-else>
                          {{ data.item.error1 >= 0 ? data.item.error1.toFixed(2) : '-' }}
                        </small>
                      </b-col>
                      <b-col cols="2" class="text-center p-0">
                        <small class="text-muted">-</small>
                      </b-col>
                      <b-col cols="5" class="text-left p-0">
                        <small v-if="isBetter(data.item.error1, data.item.error2)"> <!-- For error, lower is better -->
                          <b-badge pill class="bg-green color-black py-1 px-2 font-weight-400">
                            {{ data.item.error2 >= 0 ? data.item.error2.toFixed(2) : '-' }}
                          </b-badge>
                        </small>
                        <small v-else>
                          {{ data.item.error2 >= 0 ? data.item.error2.toFixed(2) : '-' }}
                        </small>
                      </b-col>
                    </b-row>
                  </template>
                  <!-- 95_CI Columns -->
                  <template #cell(_95_CI)="data">
                    <b-row class="m-0 p-0">
                      <b-col cols="5" class="text-right p-0">
                        <small v-if="isBetter(data.item._95_CI2, data.item._95_CI1)"> <!-- For CI, lower is better -->
                          <b-badge pill class="bg-green color-black py-1 px-2 font-weight-400">
                            {{ data.item._95_CI1 >= 0 ? data.item._95_CI1.toFixed(4) : '-' }}
                          </b-badge>
                        </small>
                        <small v-else>
                          {{ data.item._95_CI1 >= 0 ? data.item._95_CI1.toFixed(4) : '-' }}
                        </small>
                      </b-col>
                      <b-col cols="2" class="text-center p-0">
                        <small class="text-muted">-</small>
                      </b-col>
                      <b-col cols="5" class="text-left p-0">
                        <small v-if="isBetter(data.item._95_CI1, data.item._95_CI2)"> <!-- For CI, lower is better -->
                          <b-badge pill class="bg-green color-black py-1 px-2 font-weight-400">
                            {{ data.item._95_CI2 >= 0 ? data.item._95_CI2.toFixed(4) : '-' }}
                          </b-badge>
                        </small>
                        <small v-else>
                          {{ data.item._95_CI2 >= 0 ? data.item._95_CI2.toFixed(4) : '-' }}
                        </small>
                      </b-col>
                    </b-row>
                  </template>
                  <!-- TP Columns -->
                  <template #cell(TP)="data">
                    <b-row class="m-0 p-0">
                      <b-col cols="5" class="text-right p-0">
                        <small>{{ data.item.TP1 }}</small>
                      </b-col>
                      <b-col cols="2" class="text-center p-0">
                        <small class="text-muted">-</small>
                      </b-col>
                      <b-col cols="5" class="text-left p-0">
                        <small>{{ data.item.TP2 }}</small>
                      </b-col>
                    </b-row>
                  </template>
                  <!-- FP Columns -->
                  <template #cell(FP)="data">
                    <b-row class="m-0 p-0">
                      <b-col cols="5" class="text-right p-0">
                        <small>{{ data.item.FP1 }}</small>
                      </b-col>
                      <b-col cols="2" class="text-center p-0">
                        <small class="text-muted">-</small>
                      </b-col>
                      <b-col cols="5" class="text-left p-0">
                        <small>{{ data.item.FP2 }}</small>
                      </b-col>
                    </b-row>
                  </template>
                  <!-- FN Columns -->
                  <template #cell(FN)="data">
                    <b-row class="m-0 p-0">
                      <b-col cols="5" class="text-right p-0">
                        <small>{{ data.item.FN1 }}</small>
                      </b-col>
                      <b-col cols="2" class="text-center p-0">
                        <small class="text-muted">-</small>
                      </b-col>
                      <b-col cols="5" class="text-left p-0">
                        <small>{{ data.item.FN2 }}</small>
                      </b-col>
                    </b-row>
                  </template>
                  <!-- TN Columns -->
                  <template #cell(TN)="data">
                    <b-row class="m-0 p-0">
                      <b-col cols="5" class="text-right p-0">
                        <small>{{ data.item.TN1 }}</small>
                      </b-col>
                      <b-col cols="2" class="text-center p-0">
                        <small class="text-muted">-</small>
                      </b-col>
                      <b-col cols="5" class="text-left p-0">
                        <small>{{ data.item.TN2 }}</small>
                      </b-col>
                    </b-row>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </b-card-body>
  </b-card>
</template>

<style>
.scrollable {
  overflow-y: auto;
}
</style>

<script>
import { mapState, mapActions } from 'vuex'
import { IOVThesholds } from './../../../../helpers/iovthresholds'

import { labelledImagesService, projectService } from '../../../../services'

export default {
  name: 'SummaryResults',
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    selected: {
      type: Number,
      default: null
    },
    projectId: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      phases: {
        retrospective: [
          { id: 10, stub: 'setup', name: 'Project Details', icon: 'sitemap' },
          { id: 5, stub: 'setup', name: 'Project set-up', icon: 'cogs' },
          { id: 1, stub: 'collection', name: 'Data collection', icon: 'photo-video' },
          { id: 2, stub: 'preprocessing', name: 'Data pre-processing', icon: 'clone' },
          { id: 3, stub: 'annotation', name: 'Data annotation', icon: 'crop' },
          { id: 4, stub: 'truth', name: 'Reference standard', icon: 'check-double' },
          { id: 6, stub: 'run', name: 'AI Processing', icon: 'hourglass-start' },
          { id: 7, stub: 'results', name: 'Detailed results', icon: 'clipboard-list' },
          { id: 8, stub: 'summary', name: 'Results summary', icon: 'chart-area' },
          { id: 20, stub: 'comparison', name: 'AI Evaluation Comparison', icon: 'check' },
          { id: 9, stub: 'members', name: 'Members', icon: 'users-cog' }
        ],
        prospective: [
          { id: 5, stub: 'setup', name: 'Project set-up', icon: 'cogs' },
          { id: 1, stub: 'collection', name: 'Data collection', icon: 'photo-video' },
          { id: 10, stub: 'feedback', name: 'Inference feedback', icon: 'crop' },
          { id: 11, stub: 'moderation', name: 'Feedback moderation', icon: 'check-double' },
          { id: 7, stub: 'results', name: 'Detailed results', icon: 'clipboard-list' },
          { id: 8, stub: 'summary', name: 'Results summary', icon: 'chart-area' },
          { id: 9, stub: 'members', name: 'Members', icon: 'users-cog' }
        ]
      },
      expand: false,
      options: {
        chart: {
          height: 500,
          type: 'area',
          zoom: {
            enabled: false
          },
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth',
          width: 2
        },
        title: {
          text: 'Product Trends by Month',
          align: 'left',
          style: {
            color: '#ffffff',
            fontFamily: 'Lato',
            fontSize: '20px'
          }
        },
        subtitle: {
          text: 'Product Trends by Month',
          align: 'left',
          style: {
            color: '#ffffff',
            fontFamily: 'Lato',
            fontSize: '12px'
          }
        },
        legend: {
          fontFamily: 'Lato',
          fontSize: '12px',
          labels: {
            colors: ['#ffffff', '#ffffff', '#ffffff', '#ffffff']
          }
        },
        tooltip: {
          shared: true,
          theme: 'dark',
          y: {
            formatter: function (value) {
              return value.toFixed(2)
            }
          },
          x: {
            formatter: function (value) {
              return value.toFixed(2)
            }
          }
        },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.4,
            opacityTo: 0,
            stops: [0, 60, 100]
          }
        },
        grid: {
          show: false,
          xaxis: {
            lines: {
              show: false
            }
          }
        },
        xaxis: {
          labels: {
            show: false
          }
        },
        yaxis: {
          min: 0,
          max: 1,
          tickAmount: 5,
          decimalsInFloat: 2,
          labels: {
            style: {
              colors: ['#ffffff'],
              fontFamily: 'Lato',
              fontSize: '10px'
            },
            formatter: function (val) { return val.toFixed(2) }
          }
        }
      },
      pieOptions: {
        chart: {
          type: 'donut',
          toolbar: {
            show: false
          }
        },
        title: {
          text: 'Product Trends by Month',
          floating: true,
          align: 'left',
          offsetY: 0,
          style: {
            color: '#ffffff',
            fontFamily: 'Lato',
            fontSize: '24px'
          }
        },
        subtitle: {
          text: 'Product Trends by Month',
          floating: true,
          align: 'left',
          style: {
            color: '#ffffff',
            fontFamily: 'Lato',
            fontSize: '12px'
          }
        },
        legend: {
          position: 'left',
          offsetY: 50,
          fontFamily: 'Lato',
          fontSize: '12px',
          labels: {
            colors: ['#ffffff', '#ffffff', '#ffffff', '#ffffff']
          }
        },
        dataLabels: {
          style: {
            fontFamily: 'Lato, sans-serif',
            fontSize: '8px'
          }
        },
        colors: ['#28a745', '#ffc107', '#dc3545', '#17a2b8', '#2673bc'],
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 100
            },
            legend: {
              position: 'top'
            }
          }
        }]
      },
      barOptions: {
        chart: {
          type: 'bar',
          height: 100,
          stacked: true,
          stackType: '100%',
          toolbar: {
            show: false
          }
        },
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        stroke: {
          width: 1,
          colors: ['#fff']
        },
        title: {
          text: 'Product Trends by Month',
          align: 'left',
          floating: true,
          margin: 0,
          style: {
            color: '#ffffff',
            fontFamily: 'Lato',
            fontSize: '14px'
          }
        },
        fill: {
          opacity: 1
        },
        grid: {
          show: false,
          xaxis: {
            lines: {
              show: false
            }
          }
        },
        xaxis: {
          labels: {
            show: false
          },
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          }
        },
        yaxis: {
          labels: {
            show: false
          }
        },
        legend: {
          position: 'bottom',
          horizontalAlign: 'center',
          floating: true,
          offsetY: 9,
          fontFamily: 'Lato',
          fontSize: '12px',
          labels: {
            colors: '#ffffff'
          }
        }
      },
      imgAiData: [],
      imgData: [],
      proImg: [],
      fa: 0,
      pd: 0,
      fd: 0,
      conReader: 0,
      disReader: 0,
      conMod: 0,
      disMod: 0,
      accuracy: [],
      rejections: [],
      trueP: 0,
      falseP: 0,
      falseN: 0,
      IOV: 0,
      notAnnotated: 0,
      partiallyAnnotated: 0,
      fullyAnnotated: 0,
      moderated: 0,
      processed: 0,
      failProcessed: 0,
      aiMetrics: [],
      filterChoice: '',
      filterChoicePathArray: {},
      filterChoicePathArray2: [],
      tabIndex: 0,
      threshold: 0.8,
      comparativeAi: null,
      compStatus: 'None',
      compProject: null,
      compImages: null,
      compImgData: [],
      compImgAiData: [],
      compProImg: [],
      compfa: 0,
      comppd: 0,
      compfd: 0,
      compTrueP: 0,
      compFalseP: 0,
      compFalseN: 0,
      compNotAnnotated: 0,
      compPartiallyAnnotated: 0,
      compFullyAnnotated: 0,
      compModerated: 0,
      compIOV: 0,
      compAiMetrics: [],
      fields: [
        { key: 'sensitivity', label: 'Sensitivity', tdClass: '', thClass: '', width: '200' },
        { key: 'specificity', label: 'Specificity', tdClass: 'bg-navy', thClass: 'bg-navy' },
        { key: 'accuracy', label: 'Accuracy', tdClass: '', thClass: '' },
        { key: 'NPV', label: 'NPV', tdClass: 'bg-navy', thClass: 'bg-navy' },
        { key: 'PPV', label: 'PPV', tdClass: '', thClass: '' },
        { key: 'FPR', label: 'FPR', tdClass: 'bg-navy', thClass: 'bg-navy' },
        { key: 'TPR', label: 'TPR', tdClass: '', thClass: '' },
        { key: 'F1', label: 'F1', tdClass: 'bg-navy', thClass: 'bg-navy' },
        { key: 'recall', label: 'Recall', tdClass: '', thClass: '' },
        { key: 'error', label: 'Error', tdClass: 'bg-navy', thClass: 'bg-navy' },
        { key: '_95_CI', label: '95 CI', tdClass: '', thClass: '' },
        { key: 'TP', label: 'TP', tdClass: 'bg-navy', thClass: 'bg-navy' },
        { key: 'FP', label: 'FP', tdClass: '', thClass: '' },
        { key: 'FN', label: 'FN', tdClass: 'bg-navy', thClass: 'bg-navy' },
        { key: 'TN', label: 'TN', tdClass: '', thClass: '' }
      ]
    }
  },
  computed: {
    ...mapState({
      projects: (state) => state.projectSubmission.projects,
      userProjects: (state) => state.projectSubmission.projects
    }),
    ...mapState('labelledImagesSubmission', {
      images: (state) => state
    }),
    ...mapState('projectSubmission', {
      _project: (state) => state
    }),
    ...mapState('usersSubmission', { members: (state) => state }),
    getAi () {
      return this.images.aiLoaded
    },
    project () {
      const filteredProject = this.userProjects.find(
        (project) => project._id === this.projectId
      )
      return filteredProject
    },
    availableProjects () {
      const _projects = []

      this.projects.forEach(p => {
        if (p._id !== this.project._id) {
          if (p.image_subtype === this.project.image_subtype && p.image_type === this.project.image_type && p.source === this.project.source) {
            _projects.push(p)
          }
        }
      })

      return _projects
    },
    imagesLoaded () {
      return this.images.loaded
    },
    reducedImages () {
      this.filterChoicePathArray2.forEach(_key => {
        // console.log('key', _key)
      })
      var _images = this.imgData
      if (this.filterChoice !== 'All' && this.filterChoice !== '') {
        _images = _images.filter(img => this.hasGroup(img, this.filterChoice))
      }
      return _images
    },
    compReducedImages () {
      if (this.compStatus === 'Loaded') {
        this.filterChoicePathArray2.forEach(_key => {
          // console.log('key', _key)
        })
        var _images = this.compImgData
        if (this.filterChoice !== 'All' && this.filterChoice !== '') {
          _images = _images.filter(img => this.hasGroup(img, this.filterChoice))
        }
        return _images
      } else {
        return []
      }
    },
    variabilityOptions () {
      const _options = JSON.parse(JSON.stringify(this.pieOptions))
      _options.labels = ['Full Agreement', 'Partial Disagreement', 'Full Disagreement']
      _options.colors = ['#28a745', '#ffc107', '#dc3545']
      _options.title.text = !this.IOV ? 'Not Enough Data' : (this.IOV * 100).toFixed(2) + '%'
      _options.subtitle.text = 'Inter-Observer Variability'

      return _options
    },
    variabilitySeries () {
      return [this.fa, this.pd, this.fd]
    },
    readerOptions () {
      const _options = JSON.parse(JSON.stringify(this.pieOptions))
      _options.labels = ['Fully Annotated', 'Partially Annotated', 'Not Annotated']
      _options.colors = ['#28a745', '#ffc107', '#dc3545']
      _options.title.text = 'Data Annotation'
      _options.subtitle.text = 'Progress Summary'

      return _options
    },
    readerSeries () {
      return [this.fullyAnnotated, this.partiallyAnnotated, this.notAnnotated]
    },
    moderatorOptions () {
      const _options = JSON.parse(JSON.stringify(this.pieOptions))
      _options.labels = ['Moderated', 'Rejected']
      _options.colors = ['#28a745', '#dc3545']
      _options.title.text = 'Data Moderation'
      _options.subtitle.text = 'Progress Summary'
      return _options
    },
    moderatorSeries () {
      return [this.moderated, this.rejections.reduce((a, b) => a + b.count, 0)]
    },
    dataOptions () {
      const _options = JSON.parse(JSON.stringify(this.barOptions))
      _options.title.text = undefined

      return _options
    },
    dataSeries () {
      return [{
        name: 'Processed',
        data: [this.processed]
      }, {
        name: 'Failed during Processing',
        data: [0]
      }, {
        name: 'Rejected on Data Moderation',
        data: [this.rejections.find(r => r.phase === 3) ? this.rejections.find(r => r.phase === 3).count : 0]
      }, {
        name: 'Partially Annotated',
        data: [this.partiallyAnnotated]
      }, {
        name: 'Not Annotated',
        data: [this.notAnnotated]
      }, {
        name: 'Rejected on Data Processing',
        data: [this.rejections.find(r => r.phase === 2) ? this.rejections.find(r => r.phase === 2).count : 0]
      }, {
        name: 'Rejected on Reference Standard',
        data: [this.rejections.find(r => r.phase === 4) ? this.rejections.find(r => r.phase === 4).count : 0]
      }, {
        name: 'Rejected on Data Collection',
        data: [this.rejections.find(r => r.phase === 1) ? this.rejections.find(r => r.phase === 1).count : 0]
      }]
    },
    cmOptions () {
      const _options = JSON.parse(JSON.stringify(this.pieOptions))
      _options.labels = ['True Positive', 'False Positive', 'False Negative', 'True Negative']
      _options.title.text = (this.confusionMatrix.truePositive + this.confusionMatrix.falsePositive +
      this.confusionMatrix.falseNegative + this.confusionMatrix.trueNegative === 0 ? 'Not Enough Data' : (Math.round(
          (this.confusionMatrix.truePositive + this.confusionMatrix.trueNegative) /
        (this.confusionMatrix.truePositive + this.confusionMatrix.falsePositive +
        this.confusionMatrix.falseNegative + this.confusionMatrix.trueNegative) * 10000) / 100).toFixed(2) + '%')
      _options.subtitle.text = 'AI Accuracy'

      return _options
    },
    compCmOptions () {
      const _options = JSON.parse(JSON.stringify(this.pieOptions))
      _options.labels = ['True Positive', 'False Positive', 'False Negative', 'True Negative']
      _options.title.text = (this.compConfusionMatrix.truePositive + this.compConfusionMatrix.falsePositive +
      this.compConfusionMatrix.falseNegative + this.compConfusionMatrix.trueNegative === 0 ? 'Not Enough Data' : (Math.round(
          (this.compConfusionMatrix.truePositive + this.compConfusionMatrix.trueNegative) /
        (this.compConfusionMatrix.truePositive + this.compConfusionMatrix.falsePositive +
        this.compConfusionMatrix.falseNegative + this.compConfusionMatrix.trueNegative) * 10000) / 100).toFixed(2) + '%')
      _options.subtitle.text = 'AI Accuracy'

      return _options
    },
    cmSeries () {
      return [this.confusionMatrix.truePositive, this.confusionMatrix.falsePositive, this.confusionMatrix.falseNegative, this.confusionMatrix.trueNegative]
    },
    compCmSeries () {
      return [this.compConfusionMatrix.truePositive, this.compConfusionMatrix.falsePositive, this.compConfusionMatrix.falseNegative, this.compConfusionMatrix.trueNegative]
    },
    combinedAuc () {
      const rocData = this.metrics.map(point => ({
        x: 1 - point.specificity, // FPR = 1 - specificity
        y: point.sensitivity, // TPR = sensitivity
        threshold: point.threshold
      }))

      // Sort data by x value (FPR) to ensure proper curve
      rocData.sort((a, b) => a.x - b.x)

      let auc = 0
      for (let i = 1; i < rocData.length; i++) {
        const width = rocData[i].x - rocData[i - 1].x
        const height = (rocData[i].y + rocData[i - 1].y) / 2
        auc += width * height
      }

      const compRocData = this.compMetrics.map(point => ({
        x: 1 - point.specificity, // FPR = 1 - specificity
        y: point.sensitivity, // TPR = sensitivity
        threshold: point.threshold
      }))

      // Sort data by x value (FPR) to ensure proper curve
      compRocData.sort((a, b) => a.x - b.x)

      let compAuc = 0
      for (let i = 1; i < compRocData.length; i++) {
        const width = compRocData[i].x - compRocData[i - 1].x
        const height = (compRocData[i].y + compRocData[i - 1].y) / 2
        compAuc += width * height
      }

      return {
        selected: {
          auc: auc,
          rocData: rocData
        },
        comparative: {
          auc: compAuc,
          rocData: compRocData
        }
      }
    },
    aucOptions () {
      const _options = JSON.parse(JSON.stringify(this.options))
      _options.xaxis.type = 'numeric'
      _options.xaxis.min = 0
      _options.xaxis.max = 1
      _options.xaxis.categories = [0, 0.05, 0.1, 0.15, 0.2, 0.25, 0.3, 0.35, 0.4, 0.45, 0.5, 0.55, 0.6, 0.65, 0.7, 0.75, 0.8, 0.85, 0.9, 0.95]
      _options.subtitle.text = 'Area Under Curve'
      _options.title.text = `${this.list[0].name}: ${this.combinedAuc.selected.auc.toFixed(4)}, ${this.comparativeAi.name}: ${this.combinedAuc.comparative.auc.toFixed(4)}`

      return _options
    },
    aucSeries () {
      return [{
        name: this.list[0].name,
        data: [{ x: 0, y: 0 }, ...this.combinedAuc.selected.rocData]
      }, {
        name: this.comparativeAi.name,
        data: [{ x: 0, y: 0 }, ...this.combinedAuc.comparative.rocData]
      }]
    },
    combinedAuPRC () {
      const prData = this.metrics.map(point => ({
        x: point.recall,
        y: point.precision,
        threshold: point.threshold
      }))

      // Sort data by x value (FPR) to ensure proper curve
      prData.sort((a, b) => b.x - a.x)

      let auprc = 0
      let min = 1
      for (let i = 1; i < prData.length; i++) {
        const width = prData[i - 1].x - prData[i].x
        const height = (prData[i - 1].y + prData[i].y) / 2
        auprc += width * height

        if (prData[i].x < min) {
          min = prData[i].x
        }
      }

      const compPrData = this.compMetrics.map(point => ({
        x: point.recall,
        y: point.precision,
        threshold: point.threshold
      }))

      // Sort data by x value (FPR) to ensure proper curve
      compPrData.sort((a, b) => a.x - b.x)

      let compAuprc = 0
      let compMin = 1
      for (let i = 1; i < compPrData.length; i++) {
        const width = compPrData[i - 1].x - compPrData[i].x
        const height = (compPrData[i - 1].y + compPrData[i].y) / 2
        compAuprc += width * height

        if (compPrData[i].x < compMin) {
          compMin = compPrData[i].x
        }
      }

      return {
        selected: {
          auprc: auprc,
          prData: prData
        },
        comparative: {
          auprc: compAuprc,
          prData: compPrData
        },
        min: Math.min(min, compMin)
      }
    },
    compAucSeries () {
      const _sorted = this.compMetrics.slice()
      _sorted.sort((a, b) => { return a.FRP - b.FRP })

      return [{
        data: _sorted.map(__metrics => { return { x: __metrics.FPR, y: (__metrics.TPR > 1 ? __metrics.TPR : __metrics.TPR) } })
      }]
    },
    prOptions () {
      const prData = this.calculateAURPC()
      const compPrData = this.calculateAURPC(false)

      const _min1 = Math.min(...prData.uniquePoints.map(p => p.recall))
      const _min2 = Math.min(...compPrData.uniquePoints.map(p => p.recall))
      const _min = Math.min(_min1, _min2)
      const min = Math.floor(_min * 20) / 20

      const _options = JSON.parse(JSON.stringify(this.options))
      const series = [{
        name: this.list[0].name,
        data: prData.uniquePoints.map(p => ({ x: p.recall, y: p.precision }))
      }, {
        name: this.comparativeAi.name,
        data: compPrData.uniquePoints.map(p => ({ x: p.recall, y: p.precision }))
      }]
      _options.xaxis.min = min
      _options.xaxis.max = 1
      _options.xaxis.tickAmount = 5
      // _options.xaxis.categories = [0, 0.05, 0.1, 0.15, 0.2, 0.25, 0.3, 0.35, 0.4, 0.45, 0.5, 0.55, 0.6, 0.65, 0.7, 0.75, 0.8, 0.85, 0.9, 0.95]
      _options.subtitle.text = 'Precision-Recall Curve'
      _options.title.text = `${this.list[0].name}: ${prData.correctedAUPRC.toFixed(4)}, ${this.comparativeAi.name}: ${compPrData.correctedAUPRC.toFixed(4)}`

      const self = this

      _options.tooltip = {
        shared: true,
        custom: function ({ series, dataPointIndex }) {
          const point = prData.uniquePoints[dataPointIndex]
          const compPoint = compPrData.uniquePoints[dataPointIndex]
          if (point && compPoint) {
            return `<div style="padding: 10px; background: white; border-radius: 4px; box-shadow: 0 2px 8px rgba(0,0,0,0.15);">
                <span class="color-black font-weight-900">${self.list[0].name}:</span><br />
                <span class="color-black">Threshold: ${point.threshold.toFixed(2)}</span><br />
                <span class="color-black">Precision: ${point.precision.toFixed(4)}</span><br />
                <span class="color-black">Recall: ${point.recall.toFixed(4)}</span><br /><br />
                <span class="color-black font-weight-900">${self.comparativeAi.name}:</span><br />
                <span class="color-black">Threshold: ${compPoint.threshold.toFixed(2)}</span><br />
                <span class="color-black">Precision: ${compPoint.precision.toFixed(4)}</span><br />
                <span class="color-black">Recall: ${compPoint.recall.toFixed(4)}</span>
            </div>`
          }
        }
      }

      return { options: _options, series: series }
    },
    compPrOptions () {
      const _options = JSON.parse(JSON.stringify(this.options))
      _options.xaxis.type = 'numeric'
      _options.xaxis.min = 0
      _options.xaxis.max = 1
      _options.xaxis.categories = [0, 0.05, 0.1, 0.15, 0.2, 0.25, 0.3, 0.35, 0.4, 0.45, 0.5, 0.55, 0.6, 0.65, 0.7, 0.75, 0.8, 0.85, 0.9, 0.95]
      _options.title.text = this.compMetrics.find(__metrics => __metrics.threshold === 0.8) ? this.compMetrics.find(__metrics => __metrics.threshold === 0.8).accuracy.toFixed(4) : 0
      _options.subtitle.text = 'Precision-Recall Curve'

      return _options
    },
    prSeries () {
      console.log(this.combinedAuPRC)
      return [{
        name: this.list[0].name,
        data: this.combinedAuPRC.selected.prData
      }, {
        name: this.comparativeAi.name,
        data: this.combinedAuPRC.comparative.prData
      }]
    },
    compPrSeries () {
      return [{
        data: this.compMetrics.map(__metrics => { return { x: __metrics.precision, y: __metrics.recall } })
      }]
    },
    rejectWatch () {
      return !this._project.loadingRejects
    },
    readers () {
      if (this.members && this.members.members && this.members.members.length > 0 && this.project) {
        const _project = this.project._id
        const _readers = []
        this.members.members.forEach(_member => {
          const _role = _member.projectRole.find(_role => _role.project === _project)
          if (_role && _role.role === 'Reader') {
            _readers.push(_member)
          }
        })

        return _readers
      } else {
        return []
      }
    },
    moderators () {
      if (this.members && this.members.members && this.members.members.length > 0 && this.project) {
        const _project = this.project._id
        const _readers = []
        this.members.members.forEach(_member => {
          const _role = _member.projectRole.find(_role => _role.project === _project)
          if (_role && _role.role === 'Moderator') {
            _readers.push(_member)
          }
        })

        return _readers
      } else {
        return []
      }
    },
    projectImagesLoaded () {
      return !this._project.loadingProjectImages
    },
    confusionMatrix () {
      const _at50 = this.aiMetrics.find(_record => _record.threshold === Math.round(this.threshold * 100) / 100)

      if (_at50) {
        return {
          truePositive: _at50.TP,
          falsePositive: _at50.FP,
          falseNegative: _at50.FN,
          trueNegative: _at50.TN,
          sensitivity: _at50.sensitivity,
          specificity: _at50.specificity,
          precision: _at50.precision,
          npv: _at50.NPV,
          accuracy: _at50.accuracy,
          f1: _at50.F1
        }
      } else {
        return {
          truePositive: 0,
          falsePositive: 0,
          falseNegative: 0,
          trueNegative: 0
        }
      }
    },
    compConfusionMatrix () {
      const _at50 = this.compAiMetrics.find(_record => _record.threshold === Math.round(this.threshold * 100) / 100)

      if (_at50) {
        return {
          truePositive: _at50.TP,
          falsePositive: _at50.FP,
          falseNegative: _at50.FN,
          trueNegative: _at50.TN,
          sensitivity: _at50.sensitivity,
          specificity: _at50.specificity,
          precision: _at50.precision,
          npv: _at50.NPV,
          accuracy: _at50.accuracy,
          f1: _at50.F1
        }
      } else {
        return {
          truePositive: 0,
          falsePositive: 0,
          falseNegative: 0,
          trueNegative: 0
        }
      }
    },
    metrics () {
      return this.aiMetrics
    },
    compMetrics () {
      return this.compAiMetrics
    },
    dataLoaded () {
      return (this.getAi && this.projectImagesLoaded && this.imagesLoaded && this.rejectWatch)
    },
    comparisonData () {
      const result = []

      // Ensure thresholds match between the two datasets
      const thresholds = this.metrics.map(m => m.threshold)

      for (let i = 0; i < thresholds.length; i++) {
        const threshold = thresholds[i]

        // Find matching metrics for both tools
        const m1 = this.metrics.find(m => m.threshold === threshold) || {}
        const m2 = this.compMetrics.find(m => m.threshold === threshold) || {}

        result.push({
          threshold: threshold,
          sensitivity1: m1.sensitivity || NaN,
          sensitivity2: m2.sensitivity || NaN,
          specificity1: m1.specificity || NaN,
          specificity2: m2.specificity || NaN,
          accuracy1: m1.accuracy || 0,
          accuracy2: m2.accuracy || 0,
          NPV1: m1.NPV || -1,
          NPV2: m2.NPV || -1,
          precision1: m1.precision || -1,
          precision2: m2.precision || -1,
          FPR1: m1.FPR || -1,
          FPR2: m2.FPR || -1,
          TPR1: m1.TPR || -1,
          TPR2: m2.TPR || -1,
          F1_1: m1.F1 || -1,
          F1_2: m2.F1 || -1,
          recall1: m1.recall || -1,
          recall2: m2.recall || -1,
          error1: m1.error || -1,
          error2: m2.error || -1,
          _95_CI1: m1._95_CI || -1,
          _95_CI2: m2._95_CI || -1,
          TP1: m1.TP || 0,
          TP2: m2.TP || 0,
          FP1: m1.FP || 0,
          FP2: m2.FP || 0,
          FN1: m1.FN || 0,
          FN2: m2.FN || 0,
          TN1: m1.TN || 0,
          TN2: m2.TN || 0
        })
      }

      return result
    }
  },
  mounted () {
    // // console.log('ab')
    this.imgAiData = this.images.aiImages.filter(img => (!img.image.removed.find(p => p.project === this.project._id)))
    this.proImg = this._project.projectImages
    this.imgData = this.images.labelledImages.filter(img => (!img.image.removed.find(p => p.project === this.project._id)))
    this.rejections = this._project.rejects
    this.getChartData()
    this.calcMetrics()
  },
  methods: {
    ...mapActions('labelledImagesSubmission', ['fetchLabelledImages2', 'fetchAILabelledImages']),
    ...mapActions('projectSubmission', ['getProjectImages2', 'getRejections2']),
    getChartData (current = true) {
      var runningAcc = 0
      var totalAcc = 0

      if (current && this.getAi && this.projectImagesLoaded && this.imagesLoaded && this.rejectWatch) {
        this.fa = 0
        this.pd = 0
        this.fd = 0
        this.moderated = 0
        this.notAnnotated = 0
        this.partiallyAnnotated = 0
        this.fullyAnnotated = 0
        // console.log(this.getAi)
        // console.log(this.projectImagesLoaded)
        // console.log(this.imagesLoaded)
        // console.log(this.rejectWatch)
        this.reducedImages.forEach(img => {
          if (!img.image.removed.find(p => p.project === this.project._id)) {
            if (img.users.find(us => this.moderators.find(mod => mod._id === us._id))) {
              // console.log('mod')
              this.moderated++
              this.fullyAnnotated++
            } else if (img.pathologies.length > 0 && img.users.length < this.readers.length && img.users.length > 0) {
              this.partiallyAnnotated += 1
            } else if (img.pathologies.length > 0 && img.users.length > 0 && img.users.length === this.readers.length) {
              this.fullyAnnotated++
            }
            var acc
            if (img.image.accuracy.filter(a => a.project === this.project._id).length > 0) {
              acc = img.image.accuracy.filter(a => a.project === this.project._id).slice(-1)[0].value
            } else {
              acc = 0
            }
            var _acc = []
            if (img.otherImages && img.otherImages.length > 0 && img.image.image_set && img.image.image_set.name) {
              img.otherImages.forEach(_img => {
                const _accuracy = _img.image.accuracy.filter(a => a.project === this.project._id)
                if (_accuracy && _accuracy.length > 0) {
                  _acc.push(_accuracy.slice(-1)[0].value)
                }
              })
            }
            // console.log('acc', acc)
            _acc.push(acc)
            // // console.log('all acc', _acc)
            _acc = _acc.filter(a => a !== 0)
            if (_acc.length > 0) {
              // // console.log('av  acc', _acc.reduce((a, b) => a + b) / _acc.length)
              acc = _acc.reduce((a, b) => a + b) / _acc.length
            } else {
              acc = 0
            }
            if (img.pathologies.length > 0 && img.users.length >= this.readers.length) {
              runningAcc += acc
              totalAcc += 1
              // console.log('acc', acc)
              if (acc <= IOVThesholds().fullAgreement) {
                this.fa++
              } else if (acc >= IOVThesholds().fullAgreement && acc <= IOVThesholds().partialAgreement) {
                this.pd++
              } else {
                this.fd++
              }
            }
            var mpu = 0
            var pathCount = 0
            img.pathologies.forEach(p => {
              var runningPath = 0
              Object.keys(p).forEach(pkey => {
                if (pkey !== 'created_by') {
                  runningPath++
                }
              })
              pathCount += runningPath
              mpu = mpu < runningPath ? runningPath : mpu
            })
            var aiImg = this.imgAiData.find(i => img.image._id === i.image._id)
            // // console.log('ai', aiImg)
            if (aiImg) {
              this.processed += 1
              var aiCount = Object.keys(aiImg.pathologies[0]).length - 1
              // // console.log('abc', pathCount)
              // // console.log('ai', aiCount)
              // aiCount === pathCount ? 'True Positive' : aiCount > pathCount ? 'False Positive' : 'False Negative'
              if (aiCount === pathCount) {
                this.trueP++
              } else if (aiCount > pathCount) {
                this.falseP++
              } else {
                this.falseN++
              }
            }
          }
        })
        this.IOV = runningAcc / totalAcc
        this.notAnnotated = this.reducedImages.length - this.fullyAnnotated - this.partiallyAnnotated
      } else if (!current && this.compStatus === 'Loaded') {
        this.compfa = 0
        this.comppd = 0
        this.compfd = 0
        this.compModerated = 0
        this.compNotAnnotated = 0
        this.compPartiallyAnnotated = 0
        this.compFullyAnnotated = 0
        // console.log(this.getAi)
        // console.log(this.projectImagesLoaded)
        // console.log(this.imagesLoaded)
        // console.log(this.rejectWatch)
        this.compReducedImages.forEach(img => {
          if (!img.image.removed.find(p => p.project === this.project._id)) {
            if (img.users.find(us => this.moderators.find(mod => mod._id === us._id))) {
              // console.log('mod')
              this.compModerated++
              this.compFullyAnnotated++
            } else if (img.pathologies.length > 0 && img.users.length < this.readers.length && img.users.length > 0) {
              this.compPartiallyAnnotated += 1
            } else if (img.pathologies.length > 0 && img.users.length > 0 && img.users.length === this.readers.length) {
              this.compFullyAnnotated++
            }
            var acc
            if (img.image.accuracy.filter(a => a.project === this.project._id).length > 0) {
              acc = img.image.accuracy.filter(a => a.project === this.project._id).slice(-1)[0].value
            } else {
              acc = 0
            }
            var _acc = []
            if (img.otherImages && img.otherImages.length > 0 && img.image.image_set && img.image.image_set.name) {
              img.otherImages.forEach(_img => {
                const _accuracy = _img.image.accuracy.filter(a => a.project === this.project._id)
                if (_accuracy && _accuracy.length > 0) {
                  _acc.push(_accuracy.slice(-1)[0].value)
                }
              })
            }
            // console.log('acc', acc)
            _acc.push(acc)
            // // console.log('all acc', _acc)
            _acc = _acc.filter(a => a !== 0)
            if (_acc.length > 0) {
              // // console.log('av  acc', _acc.reduce((a, b) => a + b) / _acc.length)
              acc = _acc.reduce((a, b) => a + b) / _acc.length
            } else {
              acc = 0
            }
            if (img.pathologies.length > 0 && img.users.length >= this.readers.length) {
              runningAcc += acc
              totalAcc += 1
              // console.log('acc', acc)
              if (acc <= IOVThesholds().fullAgreement) {
                this.compfa++
              } else if (acc >= IOVThesholds().fullAgreement && acc <= IOVThesholds().partialAgreement) {
                this.comppd++
              } else {
                this.compfd++
              }
            }
            var mpu = 0
            var pathCount = 0
            img.pathologies.forEach(p => {
              var runningPath = 0
              Object.keys(p).forEach(pkey => {
                if (pkey !== 'created_by') {
                  runningPath++
                }
              })
              pathCount += runningPath
              mpu = mpu < runningPath ? runningPath : mpu
            })
            var aiImg = this.compImgAiData.find(i => img.image._id === i.image._id)
            // // console.log('ai', aiImg)
            if (aiImg) {
              this.processed += 1
              var aiCount = Object.keys(aiImg.pathologies[0]).length - 1
              // // console.log('abc', pathCount)
              // // console.log('ai', aiCount)
              // aiCount === pathCount ? 'True Positive' : aiCount > pathCount ? 'False Positive' : 'False Negative'
              if (aiCount === pathCount) {
                this.compTrueP++
              } else if (aiCount > pathCount) {
                this.compFalseP++
              } else {
                this.compFalseN++
              }
            }
          }
        })
        this.compIOV = runningAcc / totalAcc
        this.compNotAnnotated = this.reducedImages.length - this.fullyAnnotated - this.partiallyAnnotated
      }
      // // console.log('chart')
    },
    isBetter (value1, value2) {
      // Check if values are valid numbers
      const v1 = Number(value1)
      const v2 = Number(value2)

      if (isNaN(v1) || isNaN(v2)) return false
      if (v1 < 0 || v2 < 0) return false

      // Add a small epsilon for floating point comparison
      return v1 > v2 && Math.abs(v1 - v2) > 0.001
    },
    getPhase: function () {
      if (this.projectId) {
        const _project = this.list.find(_project => _project._id === this.projectId)
        const _phase = this.phases[_project.type.toLowerCase()].find(_phase => _phase.id === this.selected)
        return _phase.name
      } else {
        return ''
      }
    },
    getIcon: function () {
      if (this.projectId) {
        const _project = this.list.find(_project => _project._id === this.projectId)
        // console.log('_phase', _project.type.toLowerCase())
        const _phase = this.phases[_project.type.toLowerCase()].find(_phase => _phase.id === this.selected)
        return _phase.icon
      } else {
        return ''
      }
    },
    calcMetrics: function (current = true) {
      if (current && this.getAi && this.projectImagesLoaded && this.imagesLoaded && this.rejectWatch) {
        const _metrics = []

        const _temp = []
        for (let i = 0.05; i < 1; i += 0.05) {
          _temp.push({
            threshold: Math.round(i * 100) / 100
          })
        }

        _temp.forEach(__record => {
          const __metrics = {
            threshold: __record.threshold,
            TP: 0,
            FP: 0,
            FN: 0,
            TN: 0
          }

          this.reducedImages.forEach(img => {
            if (!img.image.removed.find(p => p.project === this.project._id)) {
              const _thisImage = this.proImg.find(_record => _record._id === img.image._id)
              const _moderated = img.users.filter(_record => _record.projectRole.find(__record => __record.project === this.projectId && __record.role === 'Moderator'))
              let _users = this.readers.map(_user => _user._id)
              if (_moderated.length > 0) {
                _users = this.moderators.map(_user => _user._id)
              }
              if (img.pathologies.length > 0 && img.users.length >= this.readers.length && _thisImage) {
                var mpu = 0
                // var pathCount = 0
                img.pathologies.filter(_record => _users.indexOf(_record.created_by) >= 0).forEach(p => {
                  var runningPath = 0
                  Object.keys(p).forEach(pkey => {
                    if (pkey !== 'created_by') {
                      runningPath++
                    }
                  })
                  // pathCount += runningPath
                  mpu = mpu < runningPath ? runningPath : mpu
                })
                var aiImg = this.imgAiData.find(i => img.image._id === i.image._id)
                // // console.log('ai', aiImg)
                if (aiImg) {
                  const _aiAccuracy = _thisImage.ai_accuracy.find(_record => _record.project === this.projectId)
                  const _positive = _aiAccuracy && _aiAccuracy.value ? _aiAccuracy.value > 0.00000001 : false
                  var aiCount = 0
                  Object.keys(aiImg.pathologies[0]).forEach(aiP => {
                    if (aiP !== 'created_by' && aiImg.pathologies[0][aiP].name !== 'heart' && aiImg.pathologies[0][aiP].name !== 'apchest') {
                      if (aiImg.pathologies[0][aiP].confidence >= __record.threshold) {
                        aiCount++
                      }
                    }
                  })
                  // console.log('AI', _aiAccuracy.value, _positive, aiCount, mpu)
                  if (aiCount === 0 && mpu === 0) {
                    __metrics.TN++
                  } else {
                    if (_positive) {
                      __metrics.TP++
                    } else {
                      if ((aiCount + 1) >= mpu) {
                        __metrics.FP++
                      } else {
                        __metrics.FN++
                      }
                    }
                  }
                }
              }
            }
          })

          _metrics.push(__metrics)
        })

        const _zero = {
          threshold: 0,
          TP: _metrics[0].TP + _metrics[0].FN,
          FP: _metrics[0].FP + _metrics[0].TN,
          FN: 0,
          TN: 0
        }

        _metrics.push(_zero)

        _metrics.forEach(__metrics => {
          __metrics.total = __metrics.TP + __metrics.FP + __metrics.FN + __metrics.TN
          __metrics.sensitivity = __metrics.TP / (__metrics.TP + __metrics.FN)
          __metrics.specificity = __metrics.TN / (__metrics.FP + __metrics.TN)
          __metrics.accuracy = (__metrics.TP + __metrics.TN) / __metrics.total
          __metrics.NPV = __metrics.TN / (__metrics.TN + __metrics.FN)
          __metrics.FPR = __metrics.FP / (__metrics.TN + __metrics.FP)
          __metrics.TPR = __metrics.TP / (__metrics.TP + __metrics.FN)
          __metrics.F1 = (2 * (__metrics.sensitivity * __metrics.TPR)) / (__metrics.sensitivity + __metrics.TPR)
          __metrics.recall = __metrics.sensitivity
          __metrics.precision = __metrics.TP / (__metrics.TP + __metrics.FP)
          __metrics.error = (__metrics.FP + __metrics.FN) / __metrics.total
          __metrics._95_CI = 1.96 * Math.sqrt((__metrics.error * (1 - __metrics.error)) / __metrics.total)
        })

        this.aiMetrics = _metrics.sort((a, b) => { return a.threshold - b.threshold })
      } else if (!current && this.compStatus === 'Loaded') {
        const _metrics = []

        const _temp = []
        for (let i = 0.05; i < 1; i += 0.05) {
          _temp.push({
            threshold: Math.round(i * 100) / 100
          })
        }

        _temp.forEach(__record => {
          const __metrics = {
            threshold: __record.threshold,
            TP: 0,
            FP: 0,
            FN: 0,
            TN: 0
          }

          this.compReducedImages.forEach(img => {
            if (!img.image.removed.find(p => p.project === this.project._id)) {
              const _thisImage = this.compProImg.find(_record => _record._id === img.image._id)
              const _moderated = img.users.filter(_record => _record.projectRole.find(__record => __record.project === this.projectId && __record.role === 'Moderator'))
              let _users = this.readers.map(_user => _user._id)
              if (_moderated.length > 0) {
                _users = this.moderators.map(_user => _user._id)
              }
              if (img.pathologies.length > 0 && img.users.length >= this.readers.length && _thisImage) {
                var mpu = 0
                // var pathCount = 0
                img.pathologies.filter(_record => _users.indexOf(_record.created_by) >= 0).forEach(p => {
                  var runningPath = 0
                  Object.keys(p).forEach(pkey => {
                    if (pkey !== 'created_by') {
                      runningPath++
                    }
                  })
                  // pathCount += runningPath
                  mpu = mpu < runningPath ? runningPath : mpu
                })
                var aiImg = this.compImgAiData.find(i => img.image._id === i.image._id)
                // // console.log('ai', aiImg)
                if (aiImg) {
                  const _aiAccuracy = _thisImage.ai_accuracy.find(_record => _record.project === this.projectId)
                  const _positive = _aiAccuracy && _aiAccuracy.value ? _aiAccuracy.value > 0.00000001 : false
                  var aiCount = 0
                  Object.keys(aiImg.pathologies[0]).forEach(aiP => {
                    if (aiP !== 'created_by' && aiImg.pathologies[0][aiP].name !== 'heart' && aiImg.pathologies[0][aiP].name !== 'apchest') {
                      if (aiImg.pathologies[0][aiP].confidence >= __record.threshold) {
                        aiCount++
                      }
                    }
                  })
                  // console.log('AI', _aiAccuracy.value, _positive, aiCount, mpu)
                  if (aiCount === 0 && mpu === 0) {
                    __metrics.TN++
                  } else {
                    if (_positive) {
                      __metrics.TP++
                    } else {
                      if ((aiCount + 1) >= mpu) {
                        __metrics.FP++
                      } else {
                        __metrics.FN++
                      }
                    }
                  }
                }
              }
            }
          })

          _metrics.push(__metrics)
        })

        const _zero = {
          threshold: 0,
          TP: _metrics[0].TP + _metrics[0].FN,
          FP: _metrics[0].FP + _metrics[0].TN,
          FN: 0,
          TN: 0
        }

        _metrics.push(_zero)

        _metrics.forEach(__metrics => {
          __metrics.total = __metrics.TP + __metrics.FP + __metrics.FN + __metrics.TN
          __metrics.sensitivity = __metrics.TP / (__metrics.TP + __metrics.FN)
          __metrics.specificity = __metrics.TN / (__metrics.FP + __metrics.TN)
          __metrics.accuracy = (__metrics.TP + __metrics.TN) / __metrics.total
          __metrics.NPV = __metrics.TN / (__metrics.TN + __metrics.FN)
          __metrics.FPR = __metrics.FP / (__metrics.TN + __metrics.FP)
          __metrics.TPR = __metrics.TP / (__metrics.TP + __metrics.FN)
          __metrics.F1 = (2 * (__metrics.sensitivity * __metrics.TPR)) / (__metrics.sensitivity + __metrics.TPR)
          __metrics.recall = __metrics.sensitivity
          __metrics.precision = __metrics.TP / (__metrics.TP + __metrics.FP)
          __metrics.error = (__metrics.FP + __metrics.FN) / __metrics.total
          __metrics._95_CI = 1.96 * Math.sqrt((__metrics.error * (1 - __metrics.error)) / __metrics.total)
        })

        this.compAiMetrics = _metrics.sort((a, b) => { return a.threshold - b.threshold })
      }
    },
    hasGroup (img, val) {
      var _filter = this.project.subgroups.find(sg => sg.name === val).definiation
      // console.log(_filter)
      var includeInFilter = false
      Object.keys(_filter).forEach(_key => {
        if (_key === 'Pathologies') {
          _filter[_key].forEach(path => {
            if (img.pathologies.has(path)) {
              includeInFilter = true
            }
          })
        } else if (_key === 'Tags') {
          _filter[_key].forEach(tag => {
            // console.log(img)
            if (img.tags.has(tag)) {
              includeInFilter = true
            }
          })
        } else if (_key === 'Diagnosis') {
          _filter[_key].forEach(dia => {
            if (img.diagnoses.has(dia)) {
              includeInFilter = true
            }
          })
        } else if ((img.image.metadata && img.image.metadata[0] && img.image.metadata[0] && img.image.metadata[0].values.find(_meta => _meta.name === _key) && _filter[_key].includes(img.image.metadata[0].values.find(_meta => _meta.name === _key).value))) {
          includeInFilter = true
        }
      })
      // // console.log('sg', inc ludeInFilter)
      return includeInFilter
    },
    getComparativeData: async function () {
      if (this.comparativeAi && this.comparativeAi._id) {
        const labelledImages = await labelledImagesService.getLabelledImages(this.comparativeAi._id)
        const aiLabelledImages = await labelledImagesService.getAILabelledImages(this.comparativeAi._id)
        const projectImages = await projectService.getProjectImages(this.comparativeAi._id)

        this.compProject = {
          selectedProjectId: this.comparativeAi._id,
          projectImages: projectImages.images
        }

        this.compImages = {
          aiImages: aiLabelledImages,
          labelledImages: labelledImages
        }

        this.compImgAiData = aiLabelledImages.filter(img => (!img.image.removed.find(p => p.project === this.project._id)))
        this.compProImg = projectImages.images
        this.compImgData = labelledImages.filter(img => (!img.image.removed.find(p => p.project === this.project._id)))

        this.compStatus = 'Loaded'

        this.getChartData(false)
        this.calcMetrics(false)
      }
    },
    calculateAURPC: function (current = true) {
      const metrics = current ? this.aiMetrics : this.compAiMetrics

      const uniquePoints = []
      metrics.forEach(point => {
        const isDuplicate = uniquePoints.some(p =>
          Math.abs(p.recall - point.recall) < 0.0001 &&
          Math.abs(p.precision - point.precision) < 0.0001
        )
        if (!isDuplicate) {
          uniquePoints.push(point)
        }
      })

      uniquePoints.sort((a, b) => b.recall - a.recall)

      const sortedPoints = [...uniquePoints].sort((a, b) => b.recall - a.recall)

      if (sortedPoints[sortedPoints.length - 1].recall > 0) {
        // Add an interpolated point at recall = A0
        sortedPoints.push({
          recall: 0,
          precision: 0,
          threshold: 1.0
        })
      }

      // Calculate area using interpolation
      let correctedAUPRC = 0
      for (let i = 1; i < sortedPoints.length; i++) {
        const deltaRecall = sortedPoints[i - 1].recall - sortedPoints[i].recall
        if (deltaRecall > 0) {
          // Use maximum precision in interval for interpolation
          const relevantPoints = metrics.filter(p =>
            p.recall <= sortedPoints[i - 1].recall &&
            p.recall >= sortedPoints[i].recall
          )
          const maxPrecision = Math.max(...relevantPoints.map(p => p.precision))
          correctedAUPRC += deltaRecall * maxPrecision
        }
      }

      return { uniquePoints, correctedAUPRC }
    },
    exportToCSV () {
      // Define what data to include in the CSV
      const csvData = this.comparisonData.map(item => {
        return {
          Threshold: item.threshold.toFixed(2),
          'Sensitivity (Tool 1)': !Number.isNaN(item.sensitivity1) ? item.sensitivity1.toFixed(2) : '-',
          'Sensitivity (Tool 2)': !Number.isNaN(item.sensitivity2) ? item.sensitivity2.toFixed(2) : '-',
          'Specificity (Tool 1)': !Number.isNaN(item.specificity1) ? item.specificity1.toFixed(2) : '-',
          'Specificity (Tool 2)': !Number.isNaN(item.specificity2) ? item.specificity2.toFixed(2) : '-',
          'Accuracy (Tool 1)': item.accuracy1.toFixed(2),
          'Accuracy (Tool 2)': item.accuracy2.toFixed(2),
          'NPV (Tool 1)': item.NPV1 >= 0 ? item.NPV1.toFixed(2) : '-',
          'NPV (Tool 2)': item.NPV2 >= 0 ? item.NPV2.toFixed(2) : '-',
          'PPV (Tool 1)': item.precision1 >= 0 ? item.precision1.toFixed(2) : '-',
          'PPV (Tool 2)': item.precision2 >= 0 ? item.precision2.toFixed(2) : '-',
          'FPR (Tool 1)': item.FPR1 >= 0 ? item.FPR1.toFixed(2) : '-',
          'FPR (Tool 2)': item.FPR2 >= 0 ? item.FPR2.toFixed(2) : '-',
          'TPR (Tool 1)': item.TPR1 >= 0 ? item.TPR1.toFixed(2) : '-',
          'TPR (Tool 2)': item.TPR2 >= 0 ? item.TPR2.toFixed(2) : '-',
          'F1 (Tool 1)': item.F1_1 >= 0 ? item.F1_1.toFixed(2) : '-',
          'F1 (Tool 2)': item.F1_2 >= 0 ? item.F1_2.toFixed(2) : '-',
          'Recall (Tool 1)': item.recall1 >= 0 ? item.recall1.toFixed(2) : '-',
          'Recall (Tool 2)': item.recall2 >= 0 ? item.recall2.toFixed(2) : '-',
          'Error (Tool 1)': item.error1 >= 0 ? item.error1.toFixed(2) : '-',
          'Error (Tool 2)': item.error2 >= 0 ? item.error2.toFixed(2) : '-',
          '95 CI (Tool 1)': item._95_CI1 >= 0 ? item._95_CI1.toFixed(4) : '-',
          '95 CI (Tool 2)': item._95_CI2 >= 0 ? item._95_CI2.toFixed(4) : '-',
          'TP (Tool 1)': item.TP1,
          'TP (Tool 2)': item.TP2,
          'FP (Tool 1)': item.FP1,
          'FP (Tool 2)': item.FP2,
          'FN (Tool 1)': item.FN1,
          'FN (Tool 2)': item.FN2,
          'TN (Tool 1)': item.TN1,
          'TN (Tool 2)': item.TN2
        }
      })

      // Convert to CSV format
      const headers = Object.keys(csvData[0]).map(k => k.replace('Tool 1', this.list[0].name).replace('Tool 2', this.comparativeAi.name)).join(',')
      const rows = csvData.map(row => Object.values(row).join(','))
      const csvContent = [headers, ...rows].join('\n')

      // Create a downloadable file
      const blob = new Blob([csvContent], { type: 'text/csvcharset=utf-8' })
      const url = URL.createObjectURL(blob)

      // Create a link and trigger download
      const link = document.createElement('a')
      link.setAttribute('href', url)
      link.setAttribute('download', 'metrics_comparison.csv')
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  },
  watch: {
    getAi (_new) {
      if (_new) {
        this.imgAiData = this.images.aiImages.filter(img => (!img.image.removed.find(p => p.project === this.project._id)))
        this.getChartData()
        this.calcMetrics()
      }
    },
    projectImagesLoaded (_new) {
      if (_new) {
        this.proImg = this._project.projectImages
        this.getChartData()
        this.calcMetrics()
      }
    },
    imagesLoaded (_new) {
      if (_new) {
        this.imgData = this.images.labelledImages.filter(img => (!img.image.removed.find(p => p.project === this.project._id)))
        this.getChartData()
        this.calcMetrics()
      }
    },
    rejectWatch (_new) {
      if (_new) {
        this.rejections = this._project.rejects
        this.getChartData()
        this.calcMetrics()
      }
    },
    dataLoaded (_new) {
      // console.log(_new)
    },
    filterChoice () {
      this.calcMetrics()
      this.getChartData()

      this.calcMetrics(false)
      this.getChartData(false)
    },
    comparativeAi (now, previous) {
      if (now && now !== previous) {
        this.compStatus = 'Loading'
      } else if (!now) {
        this.compStatus = 'None'

        this.compImages = null
        this.compProject = null
      }
    },
    compStatus () {
      if (this.compStatus === 'Loading') {
        console.log('Will load project ...')

        this.getComparativeData()
      }
    },
    tabIndex () {
      if (this.tabIndex === 2) {
        // Sync scrolling of frozen column with main table
        const scrollableTable = this.$el.querySelector('.scrollable-table')
        const frozenColumn = this.$el.querySelector('.frozen-column')

        if (scrollableTable && frozenColumn) {
          scrollableTable.addEventListener('scroll', function () {
            frozenColumn.scrollTop = this.scrollTop
          })
        }
      }
    }
  }
}
</script>

<style>
.bottom-to-top {
  writing-mode: vertical-lr;
  text-orientation: mixed;
}
.card-body .tabs {
  height: 100% !important;
}
.card-body .tabs .tab-pane {
  height: 100% !important;
}

.table-container {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.frozen-column {
  position: absolute;
  width: 100px; /* Adjust width as needed */
  left: 0;
  top: 0;
  z-index: 2;
  background-color: #fff;
  overflow-y: hidden;
}

.threshold-header {
  height: 68.5px; /* Match the header height of the main table */
  background-color: #f8f9fa;
  vertical-align: middle;
}

.threshold-cell {
  height: 30px; /* Match the cell height of the main table */
  vertical-align: middle;
}

.table-striped-row {
  background-color: rgba(0, 0, 0, 0.02);
}

.scrollable-table {
  overflow-x: auto;
  margin-left: 100px; /* Same as width of frozen column */
  overflow-y: hidden;
}

.scrollable-table table {
  table-layout: fixed;
  min-width: 2600px; /* Ensures the table is wide enough to scroll */
}

.scrollable-table table th, .scrollable-table table td {
  text-align: center;
}

:deep(table) {
  margin-bottom: 0;
}

:deep(th),
:deep(td) {
  text-align: center !important;
  vertical-align: middle !important;
  padding: 0.5rem !important;
  height: 35px;
}

:deep(.bg-navy) {
  background-color: rgba(33, 64, 89, 0.6) !important;
  color: #fff !important;
}

:deep(.bg-navy small) {
  color: #fff !important;
}

:deep(.bg-navy .text-muted) {
  color: rgba(255, 255, 255, 0.6) !important;
}

:deep(.bg-green) {
  background-color: rgba(40, 167, 69, 0.2);
}

:deep(.color-black) {
  color: #155724;
}

:deep(.font-weight-400) {
  font-weight: 400;
}
</style>
